import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EveReportingControlWidgetWidget } from '../../../../../services/ControlWidgetService.service';




@Component({
  selector: 'eve-user-autocomplete-input-control-widget-menu-settings',
  templateUrl: 'eve-user-autocomplete-input-control-widget-menu-settings.component.html',
  styleUrls: ['./eve-user-autocomplete-input-control-widget-menu-settings.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class EveUserAutoCompleteInputControlWidgetMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingControlWidgetWidget = null;

  constructor(

  ) {


  }
    ngOnInit(): void {
      
    }


}



